const cloudgame = {
  state: {
    showCookieSettings: false,
    showCookieDetail: false,
    isOperate: false,
    isBannerShow: false,
    isUserAcceptCookie: false, // 用户是否同意存功能cookies
    thirdLoginUserInfo: "",
  },
  mutations: {
    SET_SHOW_COOKIE_SETTINGS: (state,show) => {
      state.showCookieSettings = show;
    },
    SET_SHOW_COOKIE_DETAIL: (state,show) => {
      state.showCookieDetail = show;
    },
    SET_IS_OPERATE: (state,opt) => {
      state.isOperate = opt;
    },
    SET_IS_BANNER_SHOW: (state,show) => {
      state.isBannerShow = show;
    },
    SET_IS_USER_ACCEPT_COOKIE: (state, acc) => {
      state.isUserAcceptCookie = acc;
    },
    SET_THIRD_LOGIN_INFO: (state, info) => {
      state.thirdLoginUserInfo = info;
    }
  },
};
export default cloudgame;
